import { render, staticRenderFns } from "./Expected.vue?vue&type=template&id=ef5f534c&scoped=true&"
import script from "./Expected.vue?vue&type=script&lang=ts&"
export * from "./Expected.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5f534c",
  null
  
)

export default component.exports